import moment from 'moment'

export const formatTime = (timeStringOrMillis: moment.MomentInput, format: string) => {
  return moment(timeStringOrMillis).format(format)
}

/**
 * 期間を算出して返す.
 */
export const roundUpDurationFor = (toMillis?: number, fromMillis: number = moment().valueOf()) => {
  if(!toMillis) throw new Error("toMillis is not specified")
  
  const toStartOfMonth = moment(toMillis).startOf('month')
  const fromStartOfMonth = moment(fromMillis).startOf('month')
  const diffMonth = toStartOfMonth.diff(fromStartOfMonth, 'months', false)
  if (2 <= diffMonth) {
    return { duration: diffMonth, unit: 'months' }
  }

  const toStartOfDay = moment(toMillis).startOf('day')
  const fromStartOfDay = moment(fromMillis).startOf('day')
  const diffDays = toStartOfDay.diff(fromStartOfDay, 'days', false)
  return { duration: diffDays, unit: 'days' }
}

export const formattedDurationFor = (toMillis?: number, fromMillis?: number) => {
  const fromTime = moment(fromMillis)
  const toTime = moment(toMillis)
  const diffMillis = toTime.diff(fromTime)

  const duration = moment.duration(diffMillis)
  const hours = duration.as('hours')
  const days = duration.as("days")

  const utc = moment.utc(diffMillis)

  if(hours < 1) return utc.format('mm:ss')
  if(days < 1) return utc.format('H:mm:ss')
  return `${Math.floor(days)}:${utc.format('HH:mm:ss')}`
}